import { appLinkTreesObject } from "@megarax/links";
import tinycolor from "tinycolor2";

import { navAccent } from "../nav/navConstants";

type Props = {
  app: string;
  isUnread?: boolean;
};

export const SignalAppIcon: React.FC<Props> = ({ app, isUnread = false }) => {
  const AppIcon = appLinkTreesObject[app]?.Icon;
  if (!AppIcon) return null;

  const appColor = appLinkTreesObject[app]?.color ?? navAccent;
  const iconBackground = isUnread ? appColor : tinycolor(appColor).setAlpha(0.15).toString();

  return (
    <span
      css={{
        display: "inline-flex",
        flexShrink: 0,
        alignItems: "center",
        justifyContent: "center",
        width: "1.75rem",
        height: "1.75rem",
        borderRadius: "0.375rem",
        background: iconBackground,
        color: isUnread ? "white" : appColor,
      }}
    >
      <AppIcon css={{ width: "0.875rem", height: "0.875rem" }} />
    </span>
  );
};
